<template>
  <div class="h-100 d-flex justify-center align-center">
    <AppCard class="w-50">
      <v-row>
        <v-col class="text-center">
          <h1>{{ $t('payment.PaymentCancel.title') }}</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <font-awesome-icon
            :icon="['fal', 'circle-xmark']"
            class="text-error"
            style="font-size: 100px;"
          ></font-awesome-icon>
        </v-col>
      </v-row>
    </AppCard>
  </div>
</template>

<script>
import AppCard from '@/common/AppCard.vue'

export default {
  name: 'PaymentCancel',
  components: { AppCard },
}
</script>
